import firebase from 'firebase'
const provider = new firebase.auth.GoogleAuthProvider();

const config = {
  apiKey: "AIzaSyDWXY3d_5hhbA3peflLyX99J-6yTm770zQ",
  authDomain: "airlie-adbf0.firebaseapp.com",
  databaseURL: "https://airlie-adbf0.firebaseio.com",
  projectId: "airlie-adbf0",
  storageBucket: "airlie-adbf0.appspot.com",
  messagingSenderId: "938732370167",
  appId: "1:938732370167:web:e4baca61adc31f28eb7bf2",
  measurementId: "G-1B5V89VJ3B"
};

firebase.initializeApp(config);
firebase.analytics();

export const login = () => firebase.auth().signInWithPopup(provider);

export default firebase;